import {
  ArrowTopIcon,
  ArrowBottomIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  getArrowByPlacement,
} from './Arrows';

describe('Tooltip - Custom arrows', () => {
  test.each`
    placement         | expected
    ${'top-start'}    | ${ArrowTopIcon}
    ${'top'}          | ${ArrowTopIcon}
    ${'top-end'}      | ${ArrowTopIcon}
    ${'right-start'}  | ${ArrowRightIcon}
    ${'right'}        | ${ArrowRightIcon}
    ${'right-end'}    | ${ArrowRightIcon}
    ${'bottom-end'}   | ${ArrowBottomIcon}
    ${'bottom'}       | ${ArrowBottomIcon}
    ${'bottom-start'} | ${ArrowBottomIcon}
    ${'left-end'}     | ${ArrowLeftIcon}
    ${'left'}         | ${ArrowLeftIcon}
    ${'left-start'}   | ${ArrowLeftIcon}
  `(
    'Should return the correct SVG for $placement',
    ({ placement, expected }) => {
      expect(getArrowByPlacement(placement)).toEqual(expected);
    },
  );
});
